import { createAction, props } from '@ngrx/store'
import { AnnouncementAPIModel, PaginatedAPI } from 'src/app/models/api.model'

const actionPrefix = '[dashboard]'

export const load_announcement_summary_action = createAction(
  `${actionPrefix} load_announcement_summary_action`,
  props<{
    queryParams: {
      key: string
      value: string
    }[]
    searchRequestBody: any
  }>()
)

export const load_announcement_summary_success_action = createAction(
  `${actionPrefix} load_announcement_summary_success_action`,
  props<{ announcement: PaginatedAPI<AnnouncementAPIModel> }>()
)

export const save_announcement_action = createAction(
  `${actionPrefix} save_announcement_action`,
  props<{ announcement: AnnouncementAPIModel; files: File[]; routeTo: string }>()
)

export const save_announcement_success_action = createAction(
  `${actionPrefix} save_announcement_success_action`,
  props<{ announcement: AnnouncementAPIModel }>()
)

export const update_announcement_action = createAction(
  `${actionPrefix} update_announcement_action`,
  props<{ id: AnnouncementAPIModel; announcement: AnnouncementAPIModel; files: File[], routeTo: string }>()
)

export const update_announcement_success_action = createAction(
  `${actionPrefix} update_announcement_success_action`,
  props<{ announcement: AnnouncementAPIModel }>()
)
export const fetch_announcement_details = createAction(
  `${actionPrefix} fetch_announcement_details`,
  props<{ id: AnnouncementAPIModel }>()
)

export const fetch_announcement_details_success = createAction(
  `${actionPrefix} fetch_announcement_details_success`,
  props<{ announcement: AnnouncementAPIModel }>()
)
